module.exports = __webpack_public_path__ + "static/img/green_03_557.2207c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/green_03_557.png
// module id = IcKV
// module chunks = 0